import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import {
  BarCodeScanningResult,
  CameraView,
  PermissionResponse,
} from 'expo-camera'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  onQRCodeScanned(result: BarCodeScanningResult): void
  permission: PermissionResponse | null
}

export function ScanQRCodeView({ onQRCodeScanned, permission }: Props) {
  const styles = useStyles()
  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View style={styles.description}>
          <Text style={styles.text}>{t('scanQrDescription')}</Text>
        </View>
        {permission?.granted ? (
          <CameraView
            style={styles.camera}
            barcodeScannerSettings={{
              barcodeTypes: ['qr'],
            }}
            onBarcodeScanned={onQRCodeScanned}
          ></CameraView>
        ) : (
          <View style={styles.permissionDeniedContainer}>
            <Text style={styles.permissionDeniedText}>
              {t('cameraPermissionDeniedTitle')}
            </Text>
          </View>
        )}
      </View>
    </SafeAreaView>
  )
}
const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: { flex: 1 },
  camera: { flex: 1 },
  description: {
    padding: 20,
    backgroundColor: theme.colors.grey6,
    alignItems: 'center',
  },
  text: {
    alignSelf: 'center',
    textAlignVertical: 'center',
    textAlign: 'center',
  },
  permissionDeniedContainer: { paddingVertical: 200, paddingHorizontal: 50 },
  permissionDeniedText: {
    alignSelf: 'center',
    textAlignVertical: 'center',
    textAlign: 'center',
    fontSize: 24,
  },
}))
